import StatisticApi from './StatisticApi'
export default StatisticApi;
